import React from "react";

export const PrincipalInvestigatorIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.73351 22.3914H2.68551C2.37351 22.3674 2.15751 22.1034 2.18151 21.8154C2.49351 17.2314 6.81351 13.6554 11.9975 13.6554C17.1815 13.6554 21.5015 17.2314 21.8135 21.7914C21.8375 22.1034 21.5975 22.3434 21.3095 22.3674C20.9975 22.3914 20.7575 22.1514 20.7335 21.8634C20.4455 17.8554 16.6055 14.7354 11.9975 14.7354C7.36551 14.7354 3.52551 17.8794 3.26151 21.8874C3.23751 22.1754 2.99751 22.3914 2.73351 22.3914Z"
        fill="white"
      />
      <path
        d="M11.9975 12.5514C8.97351 12.5514 6.52551 10.1034 6.52551 7.07942C6.52551 4.05542 8.97351 1.60742 11.9975 1.60742C15.0215 1.60742 17.4695 4.05542 17.4695 7.07942C17.4695 10.1034 15.0215 12.5514 11.9975 12.5514Z"
        fill="white"
      />
      <path
        d="M17.6778 18.871H16.7059V17.9069H15.2752V18.871H14V20.3018H15.2752V21.577H16.7059V20.3018H17.6778V18.871Z"
        fill="white"
      />
    </svg>
  );
};
